import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum } from "~/types/enums";
import { usePostHog } from "posthog-js/react";
import moment from "moment/moment";
import Modal from "~/components-shared/Modal";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert } from "~/components-shared";
import RetroForm from "~/forms/RetroForm";
import retroSchema from "~/forms/RetroForm/retroSchema";
import footprintActionCreators from "~/store/footprints/actions";
import footprintSelectors from "~/store/footprints/selectors";
import Button from "../../components-shared/Button";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const RunRetroModal = () => {
  const {
    t
  } = useTranslation();
  const status = useSelector(footprintSelectors.getRetroStatus);
  const error = useSelector(footprintSelectors.getRetroError);
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({
    resolver: yupResolver(retroSchema),
    defaultValues: {
      sources: [],
      dateFrom: undefined,
      dateTo: undefined
    }
  });
  const onSubmit = handleSubmit(data => {
    data.dateFrom = moment(data.dateFrom).startOf("day").toISOString();
    data.dateTo = moment(data.dateTo).endOf("day").toISOString();
    dispatch(footprintActionCreators.runRetroStarted(data, _ref => {
      let {
        data: response
      } = _ref;
      if (response) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("RunRetroModal.retroInProgress"),
          timeout: 10000
        }));
      }
    }));
    posthog.capture(`Retro – Run`, {
      ...data
    });
  });
  const handleCancel = () => {
    dispatch(footprintActionCreators.actionChanged(null, null));
    posthog.capture(`Retro – Cancel`);
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("RunRetroModal.retrospective"),
    onClose: handleCancel,
    fullWidth: true,
    maxWidth: "560px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(RetroForm, {
    control: control,
    setValue: setValue
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("RunRetroModal.runRetro")))));
};
export default RunRetroModal;